// API client configuration for backend communication
import axios from 'axios';

const API_BASE_URL = `${process.env.REACT_APP_API_ROOT}/api/my_shopper`;

// Create axios instance with default configuration
const apiClient = axios.create({
    baseURL: API_BASE_URL,
    withCredentials: true, // Important for sending cookies
    timeout: 10000, // Default 10 seconds (can be overridden per request)
    headers: {
        'Content-Type': 'application/json',
    }
});

// Request interceptor
apiClient.interceptors.request.use(
    (config) => {
        console.log(`Making ${config.method?.toUpperCase()} request to: ${config.url}`);

        // Add Authorization header if token exists in localStorage
        const token = localStorage.getItem('accessToken');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
            console.log('Added Authorization header from localStorage');
        }

        return config;
    },
    (error) => {
        console.error('Request error:', error);
        return Promise.reject(error);
    }
);

// Response interceptor
apiClient.interceptors.response.use(
    (response) => {
        console.log('API Response:', response);
        console.log('API Response data:', response.data);
        return response;
    },
    async (error) => {
        const originalRequest = error.config;
        
        // If 401 and not already retried, and not a refresh token request, try to refresh token
        if (error.response?.status === 401 && !originalRequest._retry && !originalRequest.url?.includes('/auth/refresh')) {
            originalRequest._retry = true;
            
            try {
                await apiClient.post('/auth/refresh');
                // Retry the original request
                return apiClient(originalRequest);
            } catch (refreshError) {
                console.error('Token refresh failed:', refreshError);
                // Don't redirect here, let the AuthContext handle it
                return Promise.reject(refreshError);
            }
        }
        
        return Promise.reject(error);
    }
);

export default apiClient;

